import { render, staticRenderFns } from "./BadConnectionModal.vue?vue&type=template&id=61f6f25e&scoped=true&"
import script from "./BadConnectionModal.vue?vue&type=script&lang=js&"
export * from "./BadConnectionModal.vue?vue&type=script&lang=js&"
import style0 from "./BadConnectionModal.vue?vue&type=style&index=0&id=61f6f25e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f6f25e",
  null
  
)

export default component.exports